/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { unsetUserData } from '@/redux/slices/user/actions';

interface SponsorPlaqueState {
  isMinimized: boolean;
}

const initialState: SponsorPlaqueState = {
  isMinimized: false,
};

const sponsorPlaqueSlice = createSlice({
  name: 'sponsorPlaque',
  initialState,
  reducers: {
    setIsMinimized: (state, action: PayloadAction<boolean>) => {
      state.isMinimized = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(unsetUserData, () => initialState);
  },
});

export const { setIsMinimized } = sponsorPlaqueSlice.actions;

export default sponsorPlaqueSlice;
